/**
 * @file GroupField.tsx
 * @description Подпись поля и само поле одной парой внутри группы настроек
 * (phase19.16, SB122; uiux-settings-groups §3 — уровень 3 иерархии:
 * группа → подгруппа → подпись поля `Label`). Для полей без `htmlFor`
 * (переключатели `Segmented`, списки), где подпись не связана с полем
 * атрибутом: у самих полей — свой `aria-label`. Живёт рядом с `FieldHint`
 * (ревью партии SB122; прежде — `site-view/GroupField.tsx`).
 *
 * ```tsx
 * <GroupField label="Раскладка"><Segmented aria-label="Раскладка ленты" … /></GroupField>
 * ```
 */

import type { ReactNode } from "react";

import { Label } from "../label";
import { cn } from "@/lib/utils";

interface Props {
  label: string;
  children: ReactNode;
  className?: string;
}

export function GroupField({ label, children, className }: Props) {
  return (
    <div className={cn("flex min-w-0 flex-col gap-2", className)}>
      <Label>{label}</Label>
      {children}
    </div>
  );
}
